"use client";

import { NEW_PRODUCTS_CATEGORY_URL_ID } from "@faire/retailer-shared/categories/urlId";
import { path as c1CategoryPath } from "@faire/web-api/routes/category/c1CategoryUrlId";
import { StrictLocalizeFunction } from "@faire/web/common/localization";
import { IBreadcrumbOption } from "@faire/web/ui/Breadcrumbs";
import { IRoutingContext } from "@faire/web/ui/routing/RoutingContext";

import { IUrlId } from "@faire/retailer/models/Category/IUrlId";
import { categoryPath } from "@faire/retailer/paths/category/categoryPath";
import { getCategoryDisplayName } from "@faire/retailer/services/Categories";

interface BreadcrumbOptionsFromCategoriesProps {
  referrerCategoryName?: string;
  referrerSubCategoryNames?: string[];
  referrerCategoryUrlId: IUrlId;
  referrerSubCategoryUrlIds?: IUrlId[];
}

export const getBreadcrumbOptionsFromCategories = (
  categories: BreadcrumbOptionsFromCategoriesProps,
  strictLocalize: StrictLocalizeFunction,
  routingContext: IRoutingContext
) => {
  const {
    referrerCategoryName,
    referrerSubCategoryNames,
    referrerCategoryUrlId,
    referrerSubCategoryUrlIds,
  } = categories;

  const breadCrumbOptions: IBreadcrumbOption[] = [];

  if (!referrerCategoryName) {
    return [];
  }
  const urlId = referrerCategoryUrlId?.id;
  const label = getCategoryDisplayName(referrerCategoryName, strictLocalize);
  const path =
    urlId === NEW_PRODUCTS_CATEGORY_URL_ID ? undefined : c1CategoryPath(urlId);
  breadCrumbOptions.push({
    label,
    path,
  });

  if (
    referrerSubCategoryNames &&
    referrerCategoryUrlId &&
    referrerSubCategoryUrlIds
  ) {
    const categoryLinkArray: IUrlId[] = [];
    referrerSubCategoryNames.forEach((categoryName, index) => {
      if (
        referrerSubCategoryUrlIds &&
        index < referrerSubCategoryUrlIds.length
      ) {
        const urlId = referrerSubCategoryUrlIds?.[index];
        if (urlId) {
          categoryLinkArray.push(urlId);
        }
      }

      breadCrumbOptions.push({
        label: categoryName,
        path: categoryPath({
          urlIds: [referrerCategoryUrlId, ...categoryLinkArray],
          routingContext,
        }),
      });
    });
  }
  return breadCrumbOptions;
};
